import { render, staticRenderFns } from "./FrontendView.vue?vue&type=template&id=18a0b894&scoped=true&"
import script from "./FrontendView.vue?vue&type=script&lang=js&"
export * from "./FrontendView.vue?vue&type=script&lang=js&"
import style0 from "./FrontendView.vue?vue&type=style&index=0&id=18a0b894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a0b894",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VFadeTransition,VProgressCircular})
